import { render, staticRenderFns } from "./ToastificationNewAct.vue?vue&type=template&id=752e6f44&scoped=true"
import script from "./ToastificationNewAct.vue?vue&type=script&lang=js"
export * from "./ToastificationNewAct.vue?vue&type=script&lang=js"
import style0 from "./ToastificationNewAct.vue?vue&type=style&index=0&id=752e6f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752e6f44",
  null
  
)

export default component.exports